//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "page-feedback-popup",
    components: {},
    data() {
        return {
            saving: false,
            feedback: {
                content: '',
                image: {}
            },
        }
    },
    props: {
        value: Boolean,
        operatorId: {
            required: true
        }
    },
    computed: {
        workOrderInfo() {
            return this.$store.state.workOrder.workOrderInfo;
        }
    },
    methods: {
        onCancel() {
            this.$emit('handleCancel')
        },
        onSuccess() {
            this.$emit('handleSuccess')
        },

        /*客服反馈*/
        onSaveFeedback() {
            //客服反馈
            this.feedback.workOrderId = this.workOrderInfo.id;
            this.feedback.operateId = this.operatorId;
            this.saving = true
            abp.ajax.post('/api/services/app/WorkOrder/SaveFeedbackRecord', this.feedback).then(res => {

                this.$emit('handleSuccess')
                this.$emit('handleCancel')
            }).finally(() => {
                this.saving = false;
            });
        },

    },
    created() {

    }
}
